/*
 !!TODO: Must be reviewed after the MVP has been introduced.
 !!This file should be refactored if necessary.
 *----------------------------------------------------------*
 !!author: Christopher Bomm
*/

// import { get, compact } from 'lodash-es'

// import NAV_CONSTANTS from '@/js/components/Navigation/utils/navigation-constants.js'
// import API_CONSTANTS from '@/js/helper/api-constants.js'

// export const getAllNavigationLinks = relationships => {
//   return {
//     elements: {
//       data: compact(
//         get(relationships, [API_CONSTANTS.ELEMENTS, API_CONSTANTS.DATA], []).map((key, index) => {
//           if (key.type === NAV_CONSTANTS.LINKS) {
//             return {
//               ...key,
//             }
//           }
//         }, []),
//       ),
//     },
//   }
// }

export const getAllNavigationItems = (data, filterCallback = () => false) => {
  return Object.entries(data)
    .filter(([key, value]) => filterCallback(key, value))
    .reduce((acc, [, value]) => {
      return [...acc, ...value.data]
    }, [])
}
